'use client'
import classNames from 'classnames'
import useCollection from '@/utils/hooks/useCollection'
import React, { FC, ReactElement } from 'react'
import styles from './InscriptionBelowImage.module.css'


const InscriptionBelowImage: FC<{
	inscription: any
}> = (props): ReactElement => {
	const inscription = props.inscription
	// Preserve useCollection() subscription for cache warming (data not consumed here
	// since the email-alerts block is commented out below).
	useCollection(inscription?.collection?.slug)
	const tweetIntent = `Check out this item on @ordinalswallet 👇\nhttps://ordinalswallet.com/inscription/${inscription.id}`

	return (
		<div className={styles.root}>
			<div className={styles.belowImage}>
				<a
					className={classNames(styles.twitterRow, 'cursor-pointer')}
					href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetIntent)}`}
					target="_blank"
				>
					<img src="/twitterBlue.svg" alt="" className={styles.twitterBlue} />
					<div className={styles.twitterText}>Share</div>
				</a>
				{/* <div className={styles.alertsRow}>
                    <Input
                        type="string"
                        className={styles.emailInput}
                        inputClassName={styles.emailInputText}
                        value={email}
                        placeholder={'Email address'}
                        onChange={handleChangeInput}
                    />
                    <SuccessModal
                        open={success}
                        title="Your're getting mint alerts!"
                        intent={`gm KINGS!
                
                I just signed up for mint alerts on @ordinalswallet!
                
                join here: ordinalswallet.com
                
                plz RT`
                        }
                        onClose={handleClose}
                    />
                    <div className={classNames(styles.alertsButton, 'cursor-pointer')} onClick={handleSubmit}>
                        <div className={styles.alertText}>
                            Get alerts
                        </div>
                    </div>
                </div>
                {error && <p className="text-xs text-red-500 pl-1">{error}</p>} */}
			</div>
		</div>
	)
}

export default InscriptionBelowImage
